import { render, staticRenderFns } from "./r-job-mode.vue?vue&type=template&id=204ace54"
import script from "./r-job-mode.vue?vue&type=script&lang=js"
export * from "./r-job-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('204ace54')) {
      api.createRecord('204ace54', component.options)
    } else {
      api.reload('204ace54', component.options)
    }
    module.hot.accept("./r-job-mode.vue?vue&type=template&id=204ace54", function () {
      api.rerender('204ace54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/worker/r-job-mode.vue"
export default component.exports